import React from 'react';

import './Card.scss';

export const Card = ({titulo ,contenido, className = '',  style = {}, styleTitle= {}}) => {
   
  return (
   <div className={'card mx-1 ' + className} style={{ padding:0, justifyContent:"center", marginTop:18, ...style }}>
       <div className='card-header text-truncate px-2' style={styleTitle}>
          <span>{titulo}</span>
       </div>
       <div className={'pt-2 px-2 pb-1 cardContenido '} style={style}>
          {contenido}
       </div>
   </div>
  );
}

export default Card;